import Typography from '@/components/shared/typography/typography.component';
import { FollowLinkArrow } from '../../../../../public/Images';
import Image from 'next/image';
import styles from './styles.module.scss';

import { NewsData } from '../media-coverage.component';

const NewsArticleCard = ({ newsData }: { newsData: NewsData }) => {
  const imageStyling = {
    width: '100%',
    height: '45%',
    borderRadius: '16px',
    // objectFit: 'cover',
  };
  const arrowStyling = {
    width: 24,
    height: 28,
  };
  const logoStyling = {
    width: '60px',
    height: '37px',
    // objectFit: 'contain',
  };
  return (
    <div className={styles.cardContainer}>
      <a href={newsData.link} target="_blank" rel="noreferrer">
        <Image style={imageStyling} src={newsData.headerSrc} alt={'header_img'} />
        <div className={styles.contentSection}>
          <div className={styles.contentSection__header}>
            <Typography className={styles.contentSection__header__text} variant="subtitle2SemiBold">
              {newsData.news_media_name}
            </Typography>
            <Image style={arrowStyling} src={FollowLinkArrow} alt="arrow_outside" />
          </div>
          <Typography variant="body1Medium" className={styles.contentSection__paragraph}>
            {newsData.text}
          </Typography>
        </div>
        <div className={styles.newsMediaLogo}>
          <Image style={logoStyling} src={newsData.logoSrc} alt={'logo_image'} />
        </div>
      </a>
    </div>
  );
};
export default NewsArticleCard;
